import axios from 'axios'
import { Message } from 'element-ui'
import store from '@/store'
import Router from '../router'
import { getToken, clearUserInfo } from '@/utils/auth'

const service = axios.create({
  baseURL: process.env.BASE_API, // api 的 base_url
  timeout: 30000 // request timeout
})

const IS_USE_GATEWAY = process.env.USE_GATEWAY
// request interceptor
service.interceptors.request.use(
  config => {
    // Do something before request is sent
    config.cancelToken = new axios.CancelToken(cancel => {
      //  这个我习惯放再window 里面。
      window._axiosPromiseArr.push({ cancel })
    })
    if (!config.method || config.method === 'get') {
      const timestamp = new Date().getTime()
      var url = config.url
      if (url.startsWith('/v1/') || url.startsWith('v1/')) {
        if (url.indexOf('?') > -1) {
          url = url + '&timestamp=' + timestamp
        } else {
          url = url + '?timestamp=' + timestamp + '&'
        }
        config.url = url
      }
    }
    // 让每个请求携带token-- ['X-Token']为自定义key 请根据实际情况自行修改
    config.headers['authorization'] = 'Bearer ' + getToken()
    config.headers['cache-control'] = 'no-cache'
    if (IS_USE_GATEWAY === "false") { // eslint-disable-line
      // debugger
      config.headers['X_XH_id'] = store.getters.id
      config.headers['X_XH_username'] = (encodeURI(store.getters.username))
      config.headers['X_XH_realname'] = (encodeURI(store.getters.name))
      const departs = store.getters.departs
      if (departs && Array.isArray(departs) && departs.length > 0) {
        const depart = departs[0]
        config.headers['X_XH_departid'] = depart.id
        config.headers['X_XH_departname'] = (encodeURI(depart.departName))
        config.headers['X_XH_orgType'] = depart.orgType
      }
    }
    return config
  },
  error => {
    // Do something with request error
    console.log(error) // for debug
    Promise.reject(error)
  }
)

// response interceptor
service.interceptors.response.use(
  response => {
    const res = response.data
    // console.log(res.statusCode)
    if (res.resultCode === 401) {
      // debugger
      /* Message({
        message: res.resultMessage,
        type: 'warning',
        showClose: true
      }) */
      store.dispatch('LogOut').then(() => {
        location.reload()
      })
    } else {
      return response
    }
  },
  error => {
    if (error.response && error.response.status === 401) {
      Message({
        message: '您未登录或登录信息已失效，请重新登录',
        type: 'warning',
        showClose: true
      })
      clearUserInfo()
      // location.reload()
      Router.push('/login')
    } else {
      if (error && error.message) {
        Message({
          message: error.message,
          type: 'error',
          duration: 5 * 1000
        })
      }
    }
    return Promise.reject(error)
  }
)

export default service



// WEBPACK FOOTER //
// ./src/api/request.js